<template>
    <div class="grid grid-cols-2 w-[100vw] h-[100vh] layout-padding place-content-center ">
        <div class="col-span-2 h-full flex  flex-col justify-center items-center">
            <div class="md:text-8xl text-7xl ">404</div>
            <div class="md:text-4xl text-2xl mt-10">{{content.pageNotFound}}</div>
            <router-link to="/" class='text-center flex justify-center'
            ><div
              class="
                py-4
                px-10
                bg-primary
                w-max
                duration-700
                hover:bg-secondary
                cursor-pointer
                min-w-[216px]
              mt-8
                lg:ltr:left-[-108px] lg:rtl:right-[-108px]
              "
            >
              {{ content.backToHome }}
            </div></router-link
          >
        </div>
    </div>
</template>

<script>
export default {
    inject: ['content'],
}
</script>